import React, { useEffect, useRef, useState } from 'react'
import { Grid, Divider } from '@mui/material';
import './PostApprovalScreen.css'
import PostCard from './PostCard';
import ManagePostCard from './ManagePostCard';
import { setSocialToken, updatePostStatus } from './SocialService';
import { Loader } from '../../../components/loader/Loader';
import axios, { CancelTokenSource } from 'axios';
import { GenericPopUp } from '../../../components/popup/genericPopUp';
import { popupType } from '../../../types/types';
import { ConfirmationPopUp } from '../../../components/popup/confirmationPopUp';
import RenderSvg from '../../../components/renderSvg/RenderSvg';
import rejectEmpty from '../../../assets/image/svg/rejectEmpty.svg' // ../../../assets/image/svg/
import reviewEmpty from '../../../assets/image/svg/reviewEmpty.svg'
import acceptEmpty from '../../../assets/image/svg/acceptEmpty.svg'

export interface PostType {
  id: string;
  name: string,
  userImage: string,
  content: string,
  mediaUrl: string,
  postType:string,
  imageType:string,
  time: string,
  designation: string,
  status: string,
  outletname: string,
}

function PostApprovalScreen() {
  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const popUpSuccessMethod = useRef<() => void>();


  const tabs = {
    'PENDING':{imgSrc:reviewEmpty, noDataText:'No pending posts for review at the moment', label: 'In Review',},
    'ACCEPTED':{imgSrc:acceptEmpty, noDataText:'No posts have been accepted yet', label: 'Accepted' },
    'REJECTED':{imgSrc:rejectEmpty, noDataText:'No posts have been rejected yet', label: 'Rejected' },
  };

  const [currentTab, setCurrentTab] = useState<keyof typeof tabs>('PENDING');



  const [filteredPost, setFilteredPosts] = useState<PostType[]>([]);

  const [selectedPost, setSelectedPost] = useState<PostType>();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const cancelTokenRef = useRef<CancelTokenSource | null>(null);


  const handleSelect = (post: PostType) => {
    setSelectedPost(post);
  };

  const getAllPosts = async () => {
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel('Operation canceled due to new request.');
    }
    setIsLoading(true);
    cancelTokenRef.current = axios.CancelToken.source();

    try {
      if (!localStorage.getItem('socialToken')) {
        await setSocialToken();
      }
      const response = await axios.get(`https://social-timeline-prod.salescode.ai/timeline?status=${currentTab}&from=0&size=100`, {
        headers: { 'Authorization': localStorage.getItem('socialToken') ?? "" },
        cancelToken: cancelTokenRef.current.token,
      });

      const posts: PostType[] = [];
      response.data['hits'].forEach((post: any) => {
        posts.push({
          id: post.id,
          userImage: post.userImage,
          mediaUrl: post?.fileInfo[0]?.fileName,
          name: post.name,
          time: post.creationTime,
          content: post.description,
          designation: '',
          status: '',
          outletname: post.outletname,
          postType: post?.type,
          imageType: post?.fileInfo[0]?.provider,
        });
      });

      setFilteredPosts(posts);
      setSelectedPost(posts[0]);
      setIsLoading(false);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error);
      } else {
        setIsLoading(false);
        console.error('Error fetching posts:', error);
      }
    }
  };

  useEffect(() => {
    getAllPosts();
    return () => {
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel('Component unmounted or tab changed.');
      }
    };
  }, [currentTab])

  
  const updateStatus = (status: string, postid: string) => {
    updatePostStatus(status, postid)
    .then((res)=>{
      if(res.status==200 || res.status==201){
        //success popup
        if(status=='accepted'){
          setGenericModalSMessage('One post has been approved and successfully posted to Social')
        }else{
          setGenericModalSMessage('Your post is rejected')
        }
        setGenericModalType('Success')
        getAllPosts();
      }else{
        //something went wrong
        setGenericModalSMessage('Something Went Wrong!')
        setGenericModalType('Error')
      }
    })
    .catch((err)=>{
      //something went wrong
      setGenericModalSMessage('Something Went Wrong!')
      setGenericModalType('Error')
    })
    .finally(()=>{
      setGenericModalState(true);
    });
  }


  const handleUpdateStatus = (status: string, postid: string) => {
    //to give confirm popup for post rejection
    if(status=="rejected"){
      setConfirmationPopUp(true);
    }else{
      updateStatus(status,postid)
    }
  };


  return (
    <>
      <div className="posts_tabs_container">
        {Object.keys(tabs).map((tabKey) => {
            const key = tabKey as keyof typeof tabs;

          return (
            <button
              key={key}
              onClick={() => setCurrentTab(key)}
              className={`posts_tab_button ${currentTab === key ? 'active' : ''}`}
            >
              {tabs[key].label}
              {key === currentTab && !isLoading && <span className="tab-count">({filteredPost.length})</span>}
            </button>
          )
        })}
      </div>
      {isLoading ? <Loader sx={{ position: "absolute", top: "45%" }} />
        : filteredPost.length == 0 ?
          <div className='postapproval_empty_screen'> <img height={'65px'} className="emptyPageImg" src={tabs[currentTab].imgSrc}  />  {tabs[currentTab].noDataText}</div>
          : <Grid container spacing={4} justifyContent={'space-between'} width={'100%'} height={'88%'} margin={0} padding={'0 2rem 2rem !important'} gap={'5px'}>
            <Grid item xs={8.1} padding={"0 !important"} sx={{ height: '100%', overflow: 'auto' }}>
              <div>
                {filteredPost.map((post, index) => (
                  <>
                    <PostCard
                      key={post.id}
                      post={post}
                      isSelected={selectedPost?.id === post.id}
                      onSelect={() => handleSelect(post)} />
                    {index < filteredPost.length - 1 && (
                      <Divider sx={{ margin: '8px 0', backgroundColor: '#f2f2f2' }} />
                    )}
                  </>
                ))}
              </div>
            </Grid >
            <Grid item xs={3.5} padding={"0 !important"}>
              <ManagePostCard
                selectedPost={selectedPost}
                handleUpdateStatus={handleUpdateStatus}
              />
            </Grid>
          </Grid>}

          <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          setGenericModalState(false);
        }}
      />

      <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={"Are you sure you want to reject this post?"}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={()=>updateStatus('rejected', selectedPost?.id ?? '')}
        />

    </>
  );
}

export default PostApprovalScreen